import * as Yup from "yup";

import type CCPAForm from "@packages/types/ccpa-form";

export const initialValues: CCPAForm.Values = {
  ccpaRequestorType: "Non-California Resident",
  ccpaRequestTypeIds: [],
  firstName: "",
  lastName: "",
  streetAddress: "",
  city: "",
  state: "",
  email: "",
  phoneNumber: "",
  zipCode: "",
};

export const validationSchema = Yup.object({
  ccpaRequestorType: Yup.string().required("Please select an option"),
  ccpaRequestTypeIds: Yup.array()
    .min(1, "Please select a request type")
    .of(Yup.string().required())
    .required(),
  firstName: Yup.string().required("Please enter your first name"),
  lastName: Yup.string().required("Please enter your last name"),
  streetAddress: Yup.string()
    .min(3, "Please enter your street address")
    .matches(/[0-9]\s/, "Please enter your street address")
    .matches(/[a-zA-Z]/, "Please enter your street address")
    .required("Please enter your street address"),
  city: Yup.string().required("Please enter your city name"),
  state: Yup.string().required("Please select your state"),
  email: Yup.string().required("Please enter your email address"),
  phoneNumber: Yup.string().required("Please enter your phone number"),
  zipCode: Yup.string()
    .matches(/^[0-9]+$/, "Please enter your 5-digit zip code")
    .min(5, "Please enter your 5-digit zip code")
    .max(5, "Please enter your 5-digit zip code")
    .required("Please enter your 5-digit zip code"),
});
